// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TabContent_wrapper__1Z6Ts","isNotFound":"TabContent_isNotFound__2rXAb","bottomMark":"TabContent_bottomMark__2h8ce","notFound":"TabContent_notFound__1gwqB"};